export const BAD_REQUEST_CODE = 400;
export const INTERNAL_SERVER_ERROR = 500;



export const REQUEST_TIME_FOR_TIME_OUT_REQUEST = 3000;
export const REQUEST_RETRY = 3;